import React, { useContext } from 'react';
import { useGlobalState } from '../stateProvider/StateProvider';
import Form from '../forms/Form';
import Input from '../forms/Input';
import { QuestRoute } from '../api/QuestRoutes';
import Select from '../forms/Select';
import HamQuest from '../api/HamQuestGiver';
import Button from '../forms/Button';
import { useNavigate } from 'react-router-dom';
import WCSignUp from './WCSignUp';
import PhoneNumberInput from '../forms/formComponents/PhoneNumberInput';
import { UserContexts } from '../stateProvider/UsersContext';
import LoadingEllipsis from '../forms/LoadingEllipsis';
import { HSOptions } from '../../constants/HSOptions';
import { generateId } from '../utility/functions';
import ModalFactory from '../Modal';


const AddNewQuickSignUp = ({ isChild, ...props }) => {
    const {
        state: {
            locations
        },
    } = useGlobalState();

    const context = useContext(UserContexts);

    const navigate = useNavigate();

    const OpenUser = (id) => {
        navigate('/user/' + id, { replace: true });
    }

    const types = {
        LP: 'LicensePlate',
        RF: 'RFID',
        App: 'AppId',
    };

    return (
        <Form
            inputs={{
                // email: '',
                // confirmEmail: '',
                // firstName: '',
                // lastName: '',
                cellPhoneNumber: '',
                // zipPostalCode: '',
                // birthdayDayMonth: '',
                // birthdayDay: '',
                locationId: '',
                // washClub: '',
                mediaType: 'LicensePlate',
                tagType: 'Hamilton',
                mediaId: '',
                // state: '',
                // year: '',
                // make: '',
                // model: '',
                // color: '',
            }}
            onSubmit={e => HamQuest.post(QuestRoute.user.quickSignup, { ...e })
                .then(async res => {
                    if (!isChild) {
                        await ModalFactory.promise({
                            id: 'newUserFetch',
                            callback: context.manualRefresh(res.customerId),
                            title: (<>Fetching New User<LoadingEllipsis /></>),
                        })
                        ModalFactory.close('newUserFetch')
                    }
                    const id = generateId();
                    ModalFactory.show({
                        id,
                        title: `User Account Created`,
                        buttons: [
                            <Button
                                label={`To User's Account`}
                                onClick={() => {
                                    ModalFactory.close(id)
                                    OpenUser(res.customerId)
                                }}
                            />,
                            <WCSignUp child={isChild ? res : null} isQuickSignup={true} />
                        ],
                        type: 'success',
                        closeAfter: true
                    })
                })
            }
        >
            {({ values }) => (
                <>
                    <PhoneNumberInput
                        name='cellPhoneNumber'
                    />
                    <Select
                        name='mediaType'
                        label='Media Type'
                        options={HSOptions.user.media.types}

                        required
                    />

                    {values.mediaType === types.RF &&
                        <Select
                            name='tagType'
                            label='Tag Type'
                            options={HSOptions.user.media.tags}
                            required
                        />
                    }

                    <Input
                        label={values.mediaType === types.RF ? 'RFID' : 'License Plate'}
                        name='mediaId'
                        sanitize={e => {
                            e = e.replace(/./g, (char) => char.toUpperCase());
                            e = e.replace(/[^a-z0-9]/gi, '');
                            return e;
                        }}
                        maxLength={values.mediaType === types.RF ? 100 : 8}
                        autoComplete='off'
                        required
                    />
                    <Select
                        label='Assign to a Location'
                        name='locationId'
                        options={locations}
                        nullable
                    />
                </>
            )}
        </Form >
    )
}

export default AddNewQuickSignUp;
